export default "__VITE_ASSET__ce3f6864__"